import 'C:\\Projects\\genkei\\zumeco\\static\\doodle\\view\\DoodleOverlayImage.tsx.esbuild-plugin-windicss.css';
import { memo } from 'preact/compat';
import { useEffect, useState } from 'preact/hooks';
import { URL_IMAGE_OVERLAY } from '../../../server/src/urls';
import { notifyError } from '../../shared/notifyError';
import { defaultResponseHandler } from '../../shared/utils';
export const overlaySvgToG = (svg: string) => svg.replace(/^<svg(\s+xmlns="http:\/\/www\.w3\.org\/2000\/svg")?/u, '<g').replace(/<\/svg>$/u, '</g>');
export const DoodleOverlayImage = memo(({
  className,
  doodleId,
  id,
  type
}: {
  readonly className?: string;
  readonly doodleId: string;
  readonly id: string;
  readonly type: 'image/svg+xml';
}) => {
  const [svgContent, setSvgContent] = useState<{
    __html: string;
  }>();
  useEffect(() => {
    void fetch(URL_IMAGE_OVERLAY(doodleId, id)).then(async res => {
      if (!res.ok) {
        return defaultResponseHandler(res, notifyError);
      }
      const svg = await res.text();
      setSvgContent({
        __html: overlaySvgToG(svg)
      });
    });
  }, [doodleId, id, type]);

  // LINK / VAULT - MARKUP 連携 検証 No.10: LINK / VAULT 図面は縦横半分表示なので重ねる図形も縦横半分にします。
  // eslint-disable-next-line react/no-danger
  return <g class={'pointer-events-none ' + (className ?? '')} transform="scale(0.5)" dangerouslySetInnerHTML={svgContent} />;
});